import React, { useState, useEffect } from 'react';
import './home.css';

const Perc = ({ percentage, nch }) => {
    const [prog, setProg] = useState(0);
    const [per, setPer] = useState(percentage);

    useEffect(() => {
        let timer;

        if (percentage !== null && prog < percentage && nch) {
            timer = setTimeout(() => {
                setProg((prevProg) => Math.min(prevProg + 1, percentage));
            }, 10);
        }

        return () => clearTimeout(timer);
    }, [prog, percentage,nch]);

    useEffect(() => {
        
        if (nch === false) {
            setProg(0);
            setPer(0);
        }
    },[nch]);
    useEffect(() => {
        
        if (nch === true) {
            setPer(percentage);
        }
    }, [nch, percentage]);

    return (
        <div className="circular-progress">
            <svg className="progress-ring" width="120" height="120">
                <defs>
                    <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="blue" />
                        <stop offset="50%" stopColor="green" />
                        <stop offset="100%" stopColor="red" />
                    </linearGradient>
                </defs>
                <circle
                    className="progress-ring__circle"
                    stroke="url(#gradient)"
                    strokeWidth="8"
                    fill="transparent"
                    r="54"
                    cx="60"
                    cy="60"
                    style={{
                        strokeDasharray: 339.29,
                        strokeDashoffset: 339.29 - (prog / 100) * 339.29,
                    }}
                />
            </svg>
            <div className="percentage-text">{per}%</div>
        </div>
    );
};

export default Perc;